import { defineMessages } from '@atlassian/jira-intl';

/* eslint-disable jira/i18n/id-named-by-package */
export default defineMessages({
	breadcrumbs: {
		id: 'spa-apps.project-settings.service-desk-language-support.breadcrumbs',
		defaultMessage: 'Language support',
		description: 'breadcrumbs for Language support page',
	},
	languageSupportHeading: {
		id: 'project-settings.project-settings-spa.view-v2.servicedesk.language-support-heading',
		defaultMessage: 'Language support',
		description: 'Heading for the Language support settings page',
	},
	errorTitle: {
		id: 'spa-apps.project-settings.service-desk-language-translations.error-title',
		defaultMessage: 'We had a problem preparing your translations',
		description: 'Error title shown in case of language translation page fails to load.',
	},
	errorDescription: {
		id: 'spa-apps.project-settings.service-desk-language-translations.error-description',
		defaultMessage:
			'An unknown error occurred. Please try again or contact your system administrator if symptoms persist.',
		description: 'Error description shown in case of language translation page fails to load.',
	},
});
